import { SelectChangeEvent } from '@mui/material';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { TokenContext } from '@/Contexts/TokenContext';
import { useCallback, useContext } from 'react';
import useUser from '@/hooks/useUser';
import { UsersContext } from '@/Contexts/UsersContext';
import { Locales } from '@/models/User';
import { SelectInput } from '@/components/common/select_input/SelectInput';
import { SelectOptionProps } from '@/models/SelectOption';

function LanguageSelect() {
  const { locale } = useContext(LocaleContext);
  const { b2cId } = useContext(TokenContext);
  const { updatePreferredLanguage } = useUser();
  const { updateUserCurrent } = useContext(UsersContext);
  const { translatedText, updateLocale } = useContext(LocaleContext);

  const handleLanguageChange = useCallback(
    async (event: SelectChangeEvent<string>) => {
      if (event.target.value == null || b2cId == null) return;

      const updatedPreferredLanguage = event.target.value as Locales;
      await updatePreferredLanguage(updatedPreferredLanguage);
      updateUserCurrent((currentUser) =>
        currentUser != null ? { ...currentUser, preferredLanguage: updatedPreferredLanguage } : null
      );
      updateLocale(updatedPreferredLanguage);
      // force the select closed
    },
    [b2cId, updatePreferredLanguage, updateUserCurrent, updateLocale]
  );

  const selectOptions: SelectOptionProps[] = [
    { value: 'enUS', label: 'English' },
    { value: 'esES', label: 'Español' },
    { value: 'frFR', label: 'Français' },
    { value: 'ptBR', label: 'Português' },
    { value: 'itIT', label: 'Italiano' },
  ] satisfies SelectOptionProps[];

  return (
    <SelectInput
      id='preferredLanguage'
      label={translatedText.myaccount.preferredlanguage}
      value={locale?.toString() ?? ''}
      selectOptions={selectOptions}
      onChange={handleLanguageChange}
    />
  );
}

export default LanguageSelect;
